import React, {useContext} from 'react'
import WorkspaceContext from '../WorkspaceContext'
import useAsync from '../../../modules/asyncCache/useAsync'

export const WorkspaceSidebarBadge = ({count}) => {
    if (!count || count <= 0) return null
    return (
        <span className="flex-none inline-flex items-center justify-center min-w-4 h-4 px-1 text-2xs font-bold text-white bg-red-500 rounded-full leading-none">
            {count > 99 ? '99+' : count}
        </span>
    )
}

/**
 * createWorkspaceBadge — factory tạo badge component cho sidebar
 *
 * @param {object} config
 * @param {object} config.apiInfo      - API definition object
 * @param {function} config.getQuery   - (organization) => query object (path params)
 * @param {function} config.getCacheId - (organization) => string cache key
 * @param {function} config.selectCount - (response) => number — extract pending count
 */
export const createWorkspaceBadge = ({apiInfo, getQuery, getCacheId, selectCount}) => {
    return function WorkspaceBadge() {
        const {organization} = useContext(WorkspaceContext)
        const {response} = useAsync({
            cacheId: getCacheId(organization),
            apiInfo,
            values: {},
            query: getQuery(organization),
        })
        return <WorkspaceSidebarBadge count={selectCount(response)}/>
    }
}
